var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import TabsLayout from "../../../../Layout/TabsLayout";
import ServiceResult from "../../../../UI/ServiceResult/ServiceResult";
import useService from "../../../../Hooks/useService";
import DuplicatePersonReviewTab from "../../../../Container/DuplicateDetection/DuplicatePersonReviewTab";
import DuplicatePersonUnmergeableTab from "../../../../Container/DuplicateDetection/DuplicatePersonUnmergeableTab";
import DuplicatePersonIgnoredTab from "../../../../Container/DuplicateDetection/DuplicatePersonIgnoredTab";
import DuplicatePersonAutoMergeTab from "../../../../Container/DuplicateDetection/DuplicatePersonAutoMergeTab";
import DuplicatePersonInfoTab from "../../../../Container/DuplicateDetection/DuplicatePersonInfoTab";
import RuleSetService from "../../../../../Services/RuleSet.service";
import { getDuplicateDetectionIndexRoute } from "../AdminDuplicateDetectionRoutes";
import { AlertInfo } from "../../../../UI/StandardAlerts/StandardAlerts";
const RuleSetDetailTabs = (_a) => {
    var _b;
    var { id, currentTab, isDuplicateViewRefreshing } = _a, props = __rest(_a, ["id", "currentTab", "isDuplicateViewRefreshing"]);
    const [ruleSet, loadRuleSet] = useService(RuleSetService.get);
    const [counter, setCounter] = React.useState(0);
    React.useEffect(() => {
        loadRuleSet(id);
    }, [id, loadRuleSet]);
    // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
    const callback = (value) => {
        setCounter(value);
    };
    const tabsData = [
        {
            tab: "Info",
            content: (_jsx(ServiceResult, { state: ruleSet, children: (data) => _jsx(DuplicatePersonInfoTab, { ruleSet: data }, 1) })),
            id: "Info",
        },
        {
            tab: "Auto Mergeable",
            content: (_createElement(DuplicatePersonAutoMergeTab, Object.assign({}, props, { counterState: callback, id: id, key: 2 }))),
            id: "Simple",
        },
        {
            tab: "Review",
            content: (_jsx(DuplicatePersonReviewTab, { counterState: callback, id: id }, 3)),
            id: "Review",
        },
        {
            tab: "Unmergeable",
            content: (_jsx(DuplicatePersonUnmergeableTab, { counterState: callback, id: id }, 4)),
            id: "Unmergeable",
        },
        {
            tab: "Ignored",
            content: (_jsx(DuplicatePersonIgnoredTab, { counterState: callback, id: id }, 5)),
            id: "Ignored",
        },
    ];
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "title-block clearfix", children: [isDuplicateViewRefreshing && (_jsx(AlertInfo, { message: "New duplicates are currently being detected. They will be added to the list after this process completes. This page will not automatically refresh when duplicate detection is finished." })), _jsxs("h1", { className: "title", children: [_jsx(Link, { to: getDuplicateDetectionIndexRoute(), className: "text-decoration-none", title: "Back to rule sets", children: _jsx("span", { className: "fal fa-arrow-circle-left" }) }), " ", (_b = ruleSet.data) === null || _b === void 0 ? void 0 : _b.name, " ", (counter === 0 || counter) && currentTab && currentTab !== "Info" ? (_jsxs("span", { children: ["(", counter, ")"] })) : ("")] })] }), _jsx(TabsLayout, { enableRouting: "customRulesTab", tabs: tabsData, tabStyle: "underline", children: ({ tabs, content }) => (_jsxs("div", { children: [tabs, _jsx("div", { className: "mt-3", children: content })] })) })] }));
};
export default RuleSetDetailTabs;
